// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__19Nf-","headerLeft":"PageHeader_headerLeft__3NVJN"};